
import { Component, Vue, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { chargeforceStop, getOrderStatus } from "@/api/api-charge-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiEndOrder extends Vue {
  @Watch("modalShow")
  getVisible(val: boolean) {
    if (!val) {
      clearTimeout(this.timer);
      this.$emit("success");
    }
  }
  private title = i18n.t("orderList.endCharge");
  private formData: objAny = {};
  private modalShow = false;
  private current = -1;
  private status = "process";
  private loading = false;
  // private getSuccess = false;
  private dataStatus: string[] = ["", "", ""];
  private btnName: objAny = {
    // 0: "结束充电",
    // 1: "结束充电",
    // 2: "结束订单"
    0: i18n.t("orderList.endCharge"),
    1: i18n.t("orderList.endCharge"),
    2: i18n.t("orderList.endSuccess")
  };
  private endText: objAny = {
    // 1: "下发停止命令成功",
    // 2: "生成平台报告成功",
    // 3: "订单状态已变更为异常"
    1: i18n.t("orderList.loadingSuccess"),
    2: i18n.t("orderList.success"),
    3: i18n.t("orderList.orderError")
  };

  private timer = 0; // 定时器
  private getIndex = 0; // 请求状态的次数
  private typeIndex = 0; // 当前到了第几步
  private successIndex = 0;

  public open(data: objAny) {
    this.formData = data;

    this.typeIndex = 0;
    this.successIndex = 0;
    this.modalShow = true;
    this.loading = false;
    this.successIndex = 0;
    this.dataStatus = ["", "", ""];
  }

  public confirmClick() {
    if (this.formData.orderStatus == 0 || this.formData.orderStatus == 1) {
      this.typeIndex = 1;
      this.subData(1);
    } else if (this.formData.orderStatus == 2) {
      this.subData(4);
    }
  }
  async subData(type: number): Promise<void> {
    this.loading = true;
    await chargeforceStop({
      orderNo: this.formData.orderNo,
      strategy: type
    });
    // if (ret.status == this["$config"].apiStatus) {
    if (type == 4) {
      this.$Message.success(i18n.t("orderList.endSuccess"));
      this.modalShow = false;
      this.loading = false;
    } else {
      this.getIndex = 0;
      this.timer = setTimeout(() => {
        this.getOrderStatus();
      }, 3000);
    }
    // }
  }
  async getOrderStatus(): Promise<void> {
    // 获取状态 15s 如果没有变化就走下一个策略 this.typeIndex
    const ret = await getOrderStatus({ orderNo: this.formData.orderNo });
    // if (ret.status == this["$config"].apiStatus) {
    if (ret.data[0] == 1 || ret.data[0] == 0 || !ret.data || !ret.data[0]) {
      if (this.getIndex < 3) {
        this.getIndex = this.getIndex + 1;
        this.timer = setTimeout(() => {
          this.getOrderStatus();
        }, 3000);
      } else if (this.typeIndex < 3) {
        this.typeIndex = this.typeIndex + 1;
        this.subData(this.typeIndex);
      } else {
        // 订单状态变异常
        this.successIndex = this.typeIndex;
        this.loading = false;
      }
    } else {
      this.successIndex = this.typeIndex;
      this.loading = false;
    }
    // }
  }
}
